/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

export default [
  [
    ['minuit', 'midi', 'mat.', 'ap.m.', 'soir', 'nuit'], ,
    ['minuit', 'midi', 'du matin', 'de l’après-midi', 'du soir', 'de nuit']
  ],
  [
    ['minuit', 'midi', 'mat.', 'ap.m.', 'soir', 'nuit'], ,
    ['minuit', 'midi', 'matin', 'après-midi', 'soir', 'nuit']
  ],
  [
    '00:00', '12:00', ['04:00', '12:00'], ['12:00', '18:00'], ['18:00', '24:00'],
    ['00:00', '04:00']
  ]
];
